import { z } from "zod";

export const ProjetoImpressaoCadastroSchema = z.object({
  idProjetoImpressao: z.number().optional(),
  idProjeto: z.coerce.number().optional(),
  idCentroCusto: z.coerce.number().optional(),
  idFuncionarioSolicitante: z.coerce.number().optional(),
  idFuncionarioAprovacao: z.coerce.number().optional(),
  idFornecedor: z.coerce.number().optional(),

  dataSolicitacao: z.coerce.date().optional(),
  dataAprovacao: z.coerce.date().optional().nullable(),
  quantidade: z.coerce.number().optional(),
  cor: z.coerce.number().default(0),
  tamanho: z.string().optional(),
  observacoesSolicitacao: z.string().optional(),
  status: z.coerce.number().optional(),
  statusEmail: z.coerce.number().optional(),

  disciplinasIds: z.array(z.number()).optional(),

});

export type ProjetoImpressaoCadastroForm = z.infer<typeof ProjetoImpressaoCadastroSchema>;


export const defaultProjetoImpressaoCadastroForm: Partial<ProjetoImpressaoCadastroForm> = {
  cor: 0,

}
